var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew223({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.92,
    y: 3.16,
    width: 14.16,
    height: 9.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.6,5.12A7.16,7.16,0,0,1,4,5a2.3,2.3,0,0,1,1.63.46,1.42,1.42,0,0,1,.44,1.07A1.49,1.49,0,0,1,5,8V8a1.41,1.41,0,0,1,.82,1.14,9.13,9.13,0,0,0,.44,1.55H5.52a7.63,7.63,0,0,1-.38-1.35C5,8.55,4.67,8.26,4,8.24H3.33v2.44H2.6Zm.73,2.56h.74c.78,0,1.27-.42,1.27-1.07s-.52-1-1.29-1.05a2.56,2.56,0,0,0-.72.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.1,5.12A10,10,0,0,1,8.65,5a3.22,3.22,0,0,1,2.28.7,2.6,2.6,0,0,1,.79,2,3,3,0,0,1-.81,2.19,3.48,3.48,0,0,1-2.49.81,12.09,12.09,0,0,1-1.32-.07Zm.73,5a5,5,0,0,0,.73,0A2.16,2.16,0,0,0,11,7.75,2,2,0,0,0,8.68,5.58a4.27,4.27,0,0,0-.85.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.4,5v5.64h-.73V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew223);
export default __webpack_public_path__ + "static/media/Symbolpack_New_223.fcd260683bce79a96b8c1f7ce7937f2a.svg";
export { ForwardRef as ReactComponent };